import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { BaseQuestionGradingComponent } from '../../../bases';
import { SpeakingEmptySubmissionArea, SpeakingSettingsBadgesComponent, SpeakingSubmissionArea } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SpeakingGradingContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding24'));

var formatSubmittedAtDate = function formatSubmittedAtDate(dateRaw, locale) {
  if (!dateRaw || typeof dateRaw !== 'string' && !(dateRaw instanceof Date)) {
    return undefined;
  }

  try {
    var dateObj = new Date(dateRaw);
    if (isNaN(dateObj.getTime())) return undefined;
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'short',
      timeStyle: 'medium'
    }).format(dateObj);
  } catch (_unused) {
    return undefined;
  }
};

var getSubmittedAtRaw = function getSubmittedAtRaw(answer) {
  var _ref, _ref2, _raw$submittedAt;

  if (!answer) return undefined;
  var raw = answer;
  var props = raw.props || {};
  return (_ref = (_ref2 = (_raw$submittedAt = raw.submittedAt) !== null && _raw$submittedAt !== void 0 ? _raw$submittedAt : props.submittedAt) !== null && _ref2 !== void 0 ? _ref2 : raw.updatedAt) !== null && _ref !== void 0 ? _ref : props.updatedAt;
};

export var SpeakingGradingComponent = function SpeakingGradingComponent(_ref3) {
  var _speakingAnswer$value;

  var states = _ref3.states,
      actions = _ref3.actions;
  var speakingAnswer = states.speakingAnswer || states.answer;
  var speakingSettings = states.speakingSettings;
  var speakingLabel = states.speakingLabel;
  var audioFile = speakingAnswer === null || speakingAnswer === void 0 ? void 0 : (_speakingAnswer$value = speakingAnswer.value) === null || _speakingAnswer$value === void 0 ? void 0 : _speakingAnswer$value.audioFile;
  var submittedAtRaw = getSubmittedAtRaw(speakingAnswer);
  var submittedAtText = formatSubmittedAtDate(submittedAtRaw, states.locale);
  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsxs(SpeakingGradingContent, {
      children: [/*#__PURE__*/_jsx(SpeakingSettingsBadgesComponent, {
        settings: speakingSettings,
        label: speakingLabel,
        currentAttempts: speakingAnswer === null || speakingAnswer === void 0 ? void 0 : speakingAnswer.attemptCount,
        mode: "grading"
      }), !!audioFile && speakingAnswer ? /*#__PURE__*/_jsx(SpeakingSubmissionArea, {
        answer: speakingAnswer,
        label: speakingLabel,
        submittedAtText: submittedAtText,
        variant: "review"
      }) : /*#__PURE__*/_jsx(SpeakingEmptySubmissionArea, {
        label: speakingLabel
      })]
    })
  });
};